<section class="workspace-section">
    <div class="section-toolbar">
        <div>
            <h3>Shipment Notes</h3>
            <p>Rich internal notes stored at shipment level.</p>
        </div>
        <p-button *ngIf="!readonly()" label="Save Notes" icon="fa-solid fa-floppy-disk" [loading]="saving()" (onClick)="command.emit({ type: 'save', remarksHtml: remarksHtml() })"></p-button>
    </div>

    <div class="rich-note-card">
        <p-editor [ngModel]="remarksHtml()" [readonly]="readonly()" (ngModelChange)="remarksChanged.emit($event)" [style]="{ height: '320px' }" styleClass="shipment-note-editor">
            <ng-template pTemplate="header">
                <span class="ql-formats"><select class="ql-header" aria-label="Text style"><option value="1">Heading</option><option value="2">Subheading</option><option selected>Normal</option></select></span>
                <span class="ql-formats"><button class="ql-bold note-toolbar-button" type="button">B</button><button class="ql-italic note-toolbar-button" type="button"><em>I</em></button><button class="ql-underline note-toolbar-button" type="button"><u>U</u></button></span>
                <span class="ql-formats"><button class="ql-list note-toolbar-button" value="ordered" type="button">1.</button><button class="ql-list note-toolbar-button" value="bullet" type="button">â€¢</button></span>
                <span class="ql-formats"><button class="ql-link note-toolbar-button" type="button">Link</button><button class="ql-clean note-toolbar-button" type="button">Clear</button></span>
            </ng-template>
        </p-editor>
    </div>
</section>
